import { Box, Divider, Flex, Text, Image } from "@chakra-ui/react";

import vUser from "../../img/verifiedUser.svg";
import creditCard from "../../img/creditcard.svg";
import adsclick from "../../img/ads_click.svg";

const SafeSecure = () => {
  return (
    <Flex
      // mx={["40px", "40px", "80px", "100px"]}
      mx="auto"
      flexDirection={["column", "column", "row", "row"]}
      py="45px"
      px={["40px", "40px", "40px", "90px"]}
      height={["auto", "auto", "220px", "230px"]}
      alignItems="center"
      justifyContent="space-between"
    >
      <Box>
        <Flex mb='10px' flexDirection={["column", "column", "row", "row"]} gap="1rem">
          <Box mx='auto' pb='10px'>
            <Image src={adsclick} />
          </Box>
          <Box>
            <Text
              color="#1E1E1E"
              fontSize="16px"
              fontWeight="700"
              textAlign={["center", "center", "left", "left"]}
            >
              EASY and CONVENIENT
            </Text>
            <Text color="#9E9E9E" fontSize="14px" fontWeight="400">
              Apply for Training, Track your application, check your Postings,
              Result and much more Online.
            </Text>
          </Box>
        </Flex>
      </Box>
      <Divider
        ml={6}
        mr={6}
        orientation="vertical"
        borderWidth={1}
        color="black"
        height={"100%"}
      />
      <Box>
        <Flex mb='10px' flexDirection={["column", "column", "row", "row"]} gap="1rem">
          <Box pb='10px' mx='auto'>
            {" "}
            <Image src={vUser} />
          </Box>
          <Box>
            <Text
              color="#1E1E1E"
              textAlign={["center", "center", "left", "left"]}
              fontSize="16px"
              fontWeight="700"
            >
              SAFE AND SECURE
            </Text>
            <Text color="#9E9E9E" fontSize="14px" fontWeight="400">
              All user Interactions & Transactions are secured using industry
              best standards.
            </Text>
          </Box>
        </Flex>
      </Box>
      <Divider
        ml={6}
        mr={6}
        orientation="vertical"
        borderWidth={1}
        color="black"
        height={"100%"}
      />
      <Box>
        <Flex mb='10px' flexDirection={["column", "column", "row", "row"]} gap="1rem">
          <Box pb='10px' mx='auto'>
            <Image src={creditCard} />
          </Box>
          <Box>
            <Text
              color="#1E1E1E"
              textAlign={["center", "center", "left", "left"]}
              fontSize="16px"
              fontWeight="700"
            >
              FLEXIBLE PAYMENT
            </Text>
            <Text color="#9E9E9E" fontSize="14px" fontWeight="400">
              Manage Training Processes; Access e-Payment Options; Use on any
              Device: PC, Tablet, Mobile
            </Text>
          </Box>
        </Flex>
      </Box>
    </Flex>
  );
};

export default SafeSecure;
